<template>
    <v-container fluid>
        <loader :loading="isloading"></loader>
        <v-card>
            <v-toolbar flat color="#1d2735" dark>
                <v-toolbar-title>Guardar / Editar Proyecto</v-toolbar-title>
            </v-toolbar>
            <v-tabs horizontal>
                <!-- Pestañas -->
                <v-tab>
                    <v-icon left>mdi-book-variant-multiple</v-icon>Proyecto
                </v-tab>
                <v-tab v-if="admin || vendedor || marketing">
                    <v-icon left>mdi-account</v-icon>Cliente
                </v-tab>
                <v-tab v-if="admin">
                    <v-icon left>mdi-list-status</v-icon>Estado del Proyecto
                </v-tab>
                <v-tab v-if="admin || vendedor">
                    <v-icon left>mdi-folder-multiple-outline</v-icon>Archivo
                </v-tab>
                <v-tab v-if="admin || marketing">
                    <v-icon left>mdi-account-group</v-icon>Usuarios Asignados
                </v-tab>
                <v-tab v-if="(vendedor || role == 12) && proyecto.id != null">
                    <v-icon left>mdi-calendar</v-icon>Seguimiento
                </v-tab>
                <v-tab v-if="admin">
                    <v-icon left>mdi-cash</v-icon>Resumen Pagos
                </v-tab>
                <v-tab v-if="proyecto.id != null">
                    <v-icon left>mdi-ticket-account</v-icon>Tickets
                </v-tab>

                <!-- Pestañas -->
                <!-- Form Proyecto -->
                <v-tab-item class="pa-3 ma-1">
                    <v-card flat>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" md="7">
                                    <v-card>
                                        <v-card-title
                                            ><h3>
                                                Datos del proyecto
                                            </h3></v-card-title
                                        >
                                        <v-card-text>
                                            <v-row dense>
                                                <v-text-field
                                                    dense
                                                    outlined
                                                    :error-messages="
                                                        errors.errors['nombre']
                                                            ? errors.errors[
                                                                  'nombre'
                                                              ][0]
                                                            : null
                                                    "
                                                    v-model="proyecto.nombre"
                                                    label="Nombre"
                                                >
                                                </v-text-field>
                                            </v-row>

                                            <v-row
                                                dense
                                                justify="space-between"
                                                align="center"
                                                v-if="admin"
                                            >
                                                <v-col cols="12" md="2" lg="2">
                                                    <v-select
                                                        class="mt-7"
                                                        dense
                                                        outlined
                                                        :error-messages="
                                                            errors.errors[
                                                                'estado_id'
                                                            ]
                                                                ? errors.errors[
                                                                      'estado_id'
                                                                  ][0]
                                                                : null
                                                        "
                                                        v-model="
                                                            proyecto.estado_id
                                                        "
                                                        :items="estados"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        label="Estado"
                                                    >
                                                    </v-select>
                                                </v-col>
                                                <v-col cols="12" md="2" lg="2">
                                                    <v-text-field
                                                        class="mt-7"
                                                        dense
                                                        outlined
                                                        :error-messages="
                                                            errors.errors['pvp']
                                                                ? errors.errors[
                                                                      'pvp'
                                                                  ][0]
                                                                : null
                                                        "
                                                        v-model="proyecto.pvp"
                                                        label="Precio Proyecto"
                                                    >
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="12" md="3" lg="3">
                                                    <v-text-field
                                                        class="mt-7"
                                                        dense
                                                        outlined
                                                        :error-messages="
                                                            errors.errors['numero_pedido']
                                                                ? errors.errors[
                                                                      'numero_pedido'
                                                                  ][0]
                                                                : null
                                                        "
                                                        v-model="proyecto.numero_pedido"
                                                        label="Número de pedido"
                                                        maxlength="50"
                                                        counter
                                                    >
                                                    </v-text-field>
                                                </v-col>
                                                <v-col cols="12" md="5" lg="5">
                                                    <h5 class="text-center">
                                                        Método de cobro
                                                    </h5>
                                                    <v-btn-toggle
                                                        style="width: 100%"
                                                        dense
                                                        color="primary"
                                                        shaped
                                                        v-model="
                                                            proyecto.tipo_proyecto
                                                        "
                                                        background-color="white"
                                                    >
                                                        <v-btn
                                                            style="width: 24%"
                                                            :value="1"
                                                            text
                                                        >
                                                            Único
                                                        </v-btn>
                                                        <v-btn
                                                            style="width: 24%"
                                                            :value="2"
                                                            text
                                                        >
                                                            Mensual
                                                        </v-btn>
                                                        <v-btn
                                                            style="width: 24%"
                                                            :value="3"
                                                            text
                                                        >
                                                            Plazos
                                                        </v-btn>
                                                        <v-btn
                                                            style="width: 24%"
                                                            :value="4"
                                                            text
                                                        >
                                                            Anual
                                                        </v-btn>
                                                    </v-btn-toggle>
                                                </v-col>

                                                <!-- Campos de plazos (solo visibles cuando tipo_proyecto = 3) -->
                                                <v-col cols="12" md="6" v-if="proyecto.tipo_proyecto === 3">
                                                    <v-text-field
                                                        outlined
                                                        dense
                                                        v-model.number="proyecto.num_plazos"
                                                        label="Número de Plazos"
                                                        type="number"
                                                        min="1"
                                                        max="12"
                                                        @input="generarFechasPlazos"
                                                    >
                                                    </v-text-field>
                                                </v-col>
                                                <!-- Mostrar fechas de plazos generadas -->
                                                <v-col cols="12" v-if="proyecto.tipo_proyecto === 3 && proyecto.fechas_plazos && proyecto.fechas_plazos.length > 0">
                                                    <v-card outlined>
                                                        <v-card-title class="text-subtitle-1">
                                                            <v-icon left>mdi-calendar-multiple</v-icon>
                                                            Fechas de Plazos
                                                        </v-card-title>
                                                        <v-card-text>
                                                            <v-row v-for="(plazo, index) in proyecto.fechas_plazos" :key="index">
                                                                <v-col cols="12" md="6">
                                                                    <date-select
                                                                        outlined
                                                                        dense
                                                                        v-model="proyecto.fechas_plazos[index].fecha"
                                                                        :label="`Plazo ${index + 1} - Fecha`"
                                                                        append-icon="mdi-calendar"
                                                                    >
                                                                    </date-select>
                                                                </v-col>
                                                                <v-col cols="12" md="6">
                                                                    <v-text-field
                                                                        outlined
                                                                        dense
                                                                        v-model="proyecto.fechas_plazos[index].importe"
                                                                        :label="`Plazo ${index + 1} - Importe`"
                                                                        @input="proyecto.fechas_plazos[index].importe = inputPrice($event)"
                                                                    >
                                                                    </v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                        </v-card-text>
                                                    </v-card>
                                                </v-col>

                                                <v-col cols="12" md="4">
                                                    <v-text-field
                                                        class="mt-7"
                                                        dense
                                                        outlined
                                                        v-model="
                                                            proyecto.minutos_estimados
                                                        "
                                                        label="Minutos Estimados"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" md="4">
                                                    <h5 class="text-center">
                                                        Manejo de minutos
                                                    </h5>
                                                    <v-btn-toggle
                                                        style="width: 100%"
                                                        dense
                                                        color="primary"
                                                        shaped
                                                        v-model="
                                                            proyecto.semanal
                                                        "
                                                        background-color="white"
                                                    >
                                                        <v-btn
                                                            style="width: 32%"
                                                            :value="2"
                                                            text
                                                            >Mensual</v-btn
                                                        >
                                                        <v-btn
                                                            style="width: 32%"
                                                            :value="1"
                                                            text
                                                            >Semanal</v-btn
                                                        >
                                                        <v-btn
                                                            style="width: 32%"
                                                            :value="0"
                                                            text
                                                            >Total</v-btn
                                                        >
                                                    </v-btn-toggle>
                                                </v-col>
                                                <v-col
                                                    cols="12"
                                                    md="4"
                                                    lg="2"
                                                    v-if="proyecto.id != null"
                                                >
                                                    <div
                                                        class="pointer mt-7"
                                                        style="
                                                            display: flex;
                                                            align-items: center;
                                                        "
                                                        @click="
                                                            dialog_semaforo = true
                                                        "
                                                    >
                                                        <div
                                                            class="ball"
                                                            :style="`background-color:${getColorFacturacion.color}`"
                                                        ></div>
                                                        <div>
                                                            {{
                                                                getColorFacturacion.text
                                                            }}
                                                        </div>
                                                    </div>
                                                </v-col>
                                                <v-col cols="12" md="3">
                                                    <v-checkbox
                                                        label="Bloquear Mail"
                                                        v-model="
                                                            proyecto.no_mail
                                                        "
                                                    ></v-checkbox>
                                                </v-col>
                                                <v-col cols="12" md="3">
                                                    <v-checkbox
                                                        label="¿Es Kit?"
                                                        v-model="
                                                            proyecto.es_kit
                                                        "
                                                    ></v-checkbox>
                                                </v-col>
                                                <v-col
                                                    cols="12"
                                                    md="3"
                                                    v-if="admin"
                                                >
                                                    <v-checkbox
                                                        label="Seguimiento Proyecto"
                                                        v-model="
                                                            proyecto.seguimiento_proyecto
                                                        "
                                                    ></v-checkbox>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12">
                                                    <GastoExterno
                                                        v-model="
                                                            proyecto.gastos_externos
                                                        "
                                                    ></GastoExterno>
                                                </v-col>
                                            </v-row>
                                            <v-row dense v-if="admin">
                                                <v-col
                                                    cols="12"
                                                    md="12"
                                                    class="mt-4"
                                                >
                                                    <!-- Observaiones -->
                                                    <small
                                                        ><strong
                                                            >Observaciones</strong
                                                        ></small
                                                    >
                                                    <!-- Editor -->
                                                    <ckeditor
                                                        style="cursor: none"
                                                        :editor="editor"
                                                        v-model="
                                                            proyecto.observaciones
                                                        "
                                                        :config="editorConfig"
                                                    ></ckeditor>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                                <!-- Datos del servicio a contratar - Visible para todos los tipos de proyecto (incluidos potenciales) -->
                                <v-col cols="12" md="5">
                                    <v-card>
                                        <v-card-title
                                            ><h3>
                                                Datos del servicio a contratar
                                            </h3></v-card-title
                                        >
                                        <v-card-text>
                                            <v-row dense>
                                                <v-col cols="12">
                                                    <v-select
                                                        dense
                                                        outlined
                                                        :error-messages="
                                                            errors.errors[
                                                                'servicio_id'
                                                            ]
                                                                ? errors.errors[
                                                                      'servicio_id'
                                                                  ][0]
                                                                : null
                                                        "
                                                        v-model="
                                                            proyecto.servicio_id
                                                        "
                                                        :items="servicios"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        label="Servicio de interés"
                                                    >
                                                    </v-select>
                                                </v-col>

                                                <v-col cols="12" md="6">
                                                    <date-select
                                                        outlined
                                                        dense
                                                        v-model="
                                                            proyecto.fecha_alta
                                                        "
                                                        label="Fecha de Alta Servicio"
                                                        append-icon="mdi-calendar"
                                                    >
                                                    </date-select>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                    <date-select
                                                        outlined
                                                        dense
                                                        v-model="
                                                            proyecto.fecha_inicio_facturacion
                                                        "
                                                        label="Fecha Inicio Facturación"
                                                        append-icon="mdi-calendar"
                                                    >
                                                    </date-select>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                    <v-text-field
                                                        v-if="
                                                            proyecto.lead_form
                                                        "
                                                        readonly
                                                        dense
                                                        outlined
                                                        v-model="
                                                            proyecto.lead_form
                                                                .name
                                                        "
                                                        label="Campaña"
                                                    ></v-text-field>
                                                    <v-text-field
                                                        v-else
                                                        readonly
                                                        dense
                                                        outlined
                                                        label="Campaña"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                    <v-autocomplete
                                                        dense
                                                        outlined
                                                        :error-messages="
                                                            errors.errors[
                                                                'producto_id'
                                                            ]
                                                                ? errors.errors[
                                                                      'producto_id'
                                                                  ][0]
                                                                : null
                                                        "
                                                        v-model="
                                                            proyecto.producto_id
                                                        "
                                                        :items="productos"
                                                        item-text="nombre"
                                                        item-value="id"
                                                        label="Producto"
                                                        @change="
                                                            productoSeleccionado
                                                        "
                                                    >
                                                    </v-autocomplete>
                                                </v-col>

                                                <v-col
                                                    cols="12"
                                                    v-if="
                                                        proyecto.producto_id ==
                                                        51
                                                    "
                                                >
                                                    <v-text-field
                                                        dense
                                                        outlined
                                                        type="number"
                                                        v-model="
                                                            proyecto.num_trabajadores
                                                        "
                                                        label="Número de trabajadores"
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12">
                                                    <dynamic-select
                                                        v-model="
                                                            proyecto.producto_precios
                                                        "
                                                        :estados="
                                                            producto_precios
                                                        "
                                                        show="descripcion"
                                                        subtitle="precio"
                                                        title="Tarifas"
                                                        outlined
                                                        multiple
                                                        chips
                                                        :available-add="false"
                                                        available-delete="is_personalizado"
                                                        return-object
                                                        @delete="
                                                            deleteProductoPrecios
                                                        "
                                                        @clear="
                                                            producto_precio = {
                                                                id: null,
                                                                precio: 0,
                                                                precio_anual: 0,
                                                                min_usuarios: null,
                                                                pago_unico: false,
                                                                num_max_usuarios: null,
                                                            }
                                                        "
                                                        @update="
                                                            saveProductoPrecios(
                                                                producto_precio,
                                                                proyecto.id
                                                            )
                                                        "
                                                        @getEstado="
                                                            (index) => {
                                                                producto_precio =
                                                                    producto_precios[
                                                                        index
                                                                    ];
                                                            }
                                                        "
                                                    >
                                                        <v-row class="mt-2">
                                                            <v-col cols="12" md="6">
                                                                <v-text-field
                                                                    v-model="
                                                                        producto_precio.precio
                                                                    "
                                                                    dense
                                                                    outlined
                                                                    suffix="€"
                                                                    label="Precio Mensual"
                                                                ></v-text-field>
                                                            </v-col>
                                                            <v-col cols="12" md="6">
                                                                <v-text-field
                                                                    v-model="
                                                                        producto_precio.precio_anual
                                                                    "
                                                                    dense
                                                                    outlined
                                                                    suffix="€"
                                                                    label="Precio Anual"
                                                                ></v-text-field>
                                                            </v-col>
                                                            <v-col cols="12" md="6">
                                                                <v-text-field
                                                                    v-model.number="
                                                                        producto_precio.min_usuarios
                                                                    "
                                                                    dense
                                                                    outlined
                                                                    type="number"
                                                                    label="Número mínimo de usuarios"
                                                                ></v-text-field>
                                                            </v-col>
                                                            <v-col cols="12" md="6">
                                                                <v-text-field
                                                                    v-model.number="
                                                                        producto_precio.num_max_usuarios
                                                                    "
                                                                    dense
                                                                    outlined
                                                                    type="number"
                                                                    label="Número máximo de usuarios"
                                                                ></v-text-field>
                                                            </v-col>
                                                            <v-col cols="12">
                                                                <v-checkbox
                                                                    v-model="
                                                                        producto_precio.pago_unico
                                                                    "
                                                                    label="Pago único"
                                                                    dense
                                                                ></v-checkbox>
                                                            </v-col>
                                                        </v-row>
                                                    </dynamic-select>
                                                </v-col>

                                                <v-col cols="12" md="12">
                                                    <!-- Descripcion -->
                                                    <strong
                                                        >Detalles del Servicio
                                                        contratado</strong
                                                    >
                                                    <!-- Editor -->
                                                    <ckeditor
                                                        style="cursor: none"
                                                        :editor="editor"
                                                        v-model="
                                                            proyecto.detalle_servicio
                                                        "
                                                        :config="editorConfig"
                                                    ></ckeditor>
                                                </v-col>
                                                <v-col cols="12">
                                                    <v-divider class="my-4"></v-divider>
                                                    <div
                                                        class="d-flex align-center justify-space-between mb-3"
                                                    >
                                                        <strong
                                                            >Calculadora de
                                                            costes</strong
                                                        >
                                                        <span
                                                            class="grey--text text--darken-1 caption"
                                                            >Basado en las
                                                            tarifas
                                                            seleccionadas</span
                                                        >
                                                    </div>
                                                    <v-row dense>
                                                        <v-col cols="12" md="6">
                                                            <v-card outlined>
                                                                <v-card-title
                                                                    class="justify-space-between"
                                                                >
                                                                    <span
                                                                        >Pago
                                                                        inicial</span
                                                                    >
                                                                    <span
                                                                        class="text-h5 font-weight-bold"
                                                                        >{{
                                                                            formatPrice(
                                                                                pagoInicialTotal
                                                                            )
                                                                        }}€</span
                                                                    >
                                                                </v-card-title>
                                                                <v-card-text>
                                                                    <div
                                                                        v-if="
                                                                            pagoInicialTarifas.length ===
                                                                            0
                                                                        "
                                                                        class="grey--text text--darken-1 caption"
                                                                    >
                                                                        No hay
                                                                        tarifas
                                                                        de pago
                                                                        único
                                                                        seleccionadas.
                                                                    </div>
                                                                    <v-list
                                                                        dense
                                                                        v-else
                                                                    >
                                                                        <v-list-item
                                                                            v-for="(
                                                                                tarifa,
                                                                                index
                                                                            ) in pagoInicialTarifas"
                                                                            :key="
                                                                                tarifa.id ||
                                                                                index
                                                                            "
                                                                        >
                                                                            <v-list-item-content>
                                                                                <v-list-item-title
                                                                                    >{{
                                                                                        tarifa.descripcion ||
                                                                                        "Tarifa"
                                                                                    }}</v-list-item-title
                                                                                >
                                                                                <v-list-item-subtitle
                                                                                    >{{
                                                                                        formatPrice(
                                                                                            tarifa.precio ||
                                                                                                0
                                                                                        )
                                                                                    }}€</v-list-item-subtitle
                                                                                >
                                                                            </v-list-item-content>
                                                                        </v-list-item>
                                                                    </v-list>
                                                                </v-card-text>
                                                            </v-card>
                                                        </v-col>
                                                        <v-col cols="12" md="6">
                                                            <v-card outlined>
                                                                <v-card-title
                                                                    class="justify-space-between"
                                                                >
                                                                    <span
                                                                        >Pago
                                                                        recurrente</span
                                                                    >
                                                                    <span
                                                                        class="text-h5 font-weight-bold"
                                                                        >{{
                                                                            formatPrice(
                                                                                pagoRecurrenteTotal
                                                                            )
                                                                        }}€</span
                                                                    >
                                                                </v-card-title>
                                                                <v-card-text>
                                                                    <div
                                                                        class="grey--text text--darken-1 caption mb-2"
                                                                    >
                                                                        Mostrando
                                                                        {{
                                                                            textoPagoRecurrente
                                                                        }}.
                                                                    </div>
                                                                    <div
                                                                        v-if="
                                                                            pagoRecurrenteTarifas.length ===
                                                                            0
                                                                        "
                                                                        class="grey--text text--darken-1 caption"
                                                                    >
                                                                        No hay
                                                                        tarifas
                                                                        recurrentes
                                                                        seleccionadas.
                                                                    </div>
                                                                    <v-list
                                                                        dense
                                                                        v-else
                                                                    >
                                                <v-list-item
                                                                            v-for="(
                                                                                tarifa,
                                                                                index
                                                                            ) in pagoRecurrenteTarifasConImporte"
                                                                            :key="
                                                                                tarifa.id ||
                                                                                index
                                                                            "
                                                                        >
                                                                            <v-list-item-content>
                                                                                <v-list-item-title
                                                                                    class="font-weight-bold mb-1"
                                                                                    >{{
                                                                                        tarifa.descripcion ||
                                                                                        "Tarifa"
                                                                                    }}</v-list-item-title
                                                                                >
                                                                                <div
                                                                                    class="mt-1"
                                                                                >
                                                                                    <div
                                                                                        class="caption grey--text text--darken-1"
                                                                                    >
                                                                                        <template v-if="proyecto.tipo_proyecto === 4">
                                                                                            <!-- Proyecto anual: usar precio_anual si existe, sino precio, y multiplicar por 12 -->
                                                                                            <div>
                                                                                                <template v-if="tarifa.precio_anual && Number(tarifa.precio_anual) > 0">
                                                                                                    Precio anual: {{
                                                                                                        formatPrice(
                                                                                                            tarifa.precio_anual
                                                                                                        )
                                                                                                    }}€ × 12 meses = {{
                                                                                                        formatPrice(
                                                                                                            (Number(tarifa.precio_anual) * 12)
                                                                                                        )
                                                                                                    }}€
                                                                                                </template>
                                                                                                <template v-else>
                                                                                                    Precio mensual: {{
                                                                                                        formatPrice(
                                                                                                            tarifa.precio || 0
                                                                                                        )
                                                                                                    }}€ × 12 meses = {{
                                                                                                        formatPrice(
                                                                                                            (Number(tarifa.precio || 0) * 12)
                                                                                                        )
                                                                                                    }}€
                                                                                                </template>
                                                                                            </div>
                                                                                            <div
                                                                                                v-if="!tarifa.fijo && proyecto.num_trabajadores > 0"
                                                                                                class="mt-1"
                                                                                            >
                                                                                                × {{
                                                                                                    proyecto.num_trabajadores
                                                                                                }}
                                                                                                trabajadores
                                                                                            </div>
                                                                                        </template>
                                                                                        <template v-else>
                                                                                            <!-- Proyecto mensual -->
                                                                                            <div>
                                                                                                Precio mensual: {{
                                                                                                    formatPrice(
                                                                                                        tarifa.precio || 0
                                                                                                    )
                                                                                                }}€
                                                                                            </div>
                                                                                            <div
                                                                                                v-if="!tarifa.fijo && proyecto.num_trabajadores > 0"
                                                                                                class="mt-1"
                                                                                            >
                                                                                                × {{
                                                                                                    proyecto.num_trabajadores
                                                                                                }}
                                                                                                trabajadores
                                                                                            </div>
                                                                                        </template>
                                                                                    </div>
                                                                                    <div
                                                                                        class="mt-1 font-weight-medium"
                                                                                    >
                                                                                        Total: {{
                                                                                            formatPrice(
                                                                                                tarifa.importeCalculado
                                                                                            )
                                                                                        }}€
                                                                                    </div>
                                                                                </div>
                                                                            </v-list-item-content>
                                                                        </v-list-item>
                                                                    </v-list>
                                                                </v-card-text>
                                                            </v-card>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
                <!-- Form Proyecto -->

                <!-- Form Cliente -->
                <v-tab-item
                    class="pa-3 ma-1"
                    v-if="admin || vendedor || marketing"
                >
                    <form-usuario
                        :usuarios="usuarios"
                        :provincias="provincias"
                        :editorConfig="editorConfig"
                        :editor="editor"
                        :editorData="editorData"
                        :errors="errors"
                        :proyecto="proyecto"
                        :empleados="empleados"
                    >
                    </form-usuario>
                </v-tab-item>
                <!-- Form Cliente -->

                <!-- Form Estado del Proyecto -->
                <v-tab-item class="pa-3 ma-1" v-if="admin">
                    <v-card flat>
                        <div class="font-weight-bold mb-3 black--text">
                            PROGRESO DEL PROYECTO
                        </div>
                        <v-row dense>
                            <v-col cols="12" md="6" class="mt-2">
                                <dynamic_select
                                    v-model="estado.id_estado"
                                    title="Estados"
                                    show="nombre"
                                    item-value="id"
                                    :estados="proyecto_estados"
                                    @delete="deleteProyectoEstado"
                                    @create="saveproyectoEstado"
                                    @clear="save_estado = {}"
                                    @update="saveproyectoEstado"
                                    @getEstado="
                                        (index) => {
                                            save_estado =
                                                proyecto_estados[index];
                                        }
                                    "
                                >
                                    <v-row>
                                        <v-col cols="12">
                                            <v-text-field
                                                label="Nombre"
                                                v-model="save_estado.nombre"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </dynamic_select>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-menu
                                    ref="menu3"
                                    v-model="menu3"
                                    :close-on-content-click="false"
                                    :return-value.sync="fecha"
                                    transition="scale-transition"
                                    :error-messages="
                                        errors.errors.fecha
                                            ? errors.errors.fecha[0]
                                            : null
                                    "
                                    offset-y
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="fecha"
                                            label="Fecha"
                                            append-icon="mdi-calendar"
                                            v-bind="attrs"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        color="#1d2735"
                                        first-day-of-week="1"
                                        v-model="fecha"
                                        no-title
                                        scrollable
                                    >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            text
                                            color="red"
                                            @click="menu2 = false"
                                            ><strong>Cancelar</strong></v-btn
                                        >
                                        <v-btn
                                            text
                                            color="success"
                                            @click="$refs.menu3.save(fecha)"
                                            ><strong>OK</strong></v-btn
                                        >
                                    </v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col md="6">
                                <v-switch
                                    v-if="finalizado == false && descripcion"
                                    v-model="finalizado"
                                    label="En Progreso"
                                    color="light-green accent-4"
                                ></v-switch>
                                <v-switch
                                    v-if="finalizado == true && descripcion"
                                    v-model="finalizado"
                                    label="Finalizado"
                                    color="light-green accent-4"
                                ></v-switch>
                            </v-col>
                            <!--  -->
                            <v-col cols="12" md="3">
                                <v-text-field
                                    dense
                                    outlined
                                    v-model="proyecto.porc_realizado"
                                    label="% Realizado"
                                ></v-text-field>
                            </v-col>
                            <v-col md="3" cols="6">
                                <v-switch
                                    v-if="proyecto.activo == false"
                                    v-model="proyecto.activo"
                                    label="Proyecto Inactivo"
                                    color="light-green accent-4"
                                ></v-switch>
                                <v-switch
                                    v-if="proyecto.activo == true"
                                    v-model="proyecto.activo"
                                    label="Proyecto Activo"
                                    color="light-green accent-4"
                                ></v-switch>
                            </v-col>
                            <!--  -->
                        </v-row>
                        <div class="mb-5">
                            <v-btn
                                v-if="estado.id_estado"
                                @click="addStatus()"
                                color="primary"
                                class="white--text"
                                rounded
                                >Agregar progreso</v-btn
                            >
                        </div>
                        <v-data-table
                            :headers="headers"
                            :items="itemsEstado"
                            :items-per-page="5"
                            class="elevation-1"
                        >
                            <template v-slot:item.descripcion="{ item }">{{
                                item.estado == null
                                    ? item.descripcion
                                    : item.estado.nombre
                            }}</template>
                            <template v-slot:item.fecha="{ item }">{{
                                item.fecha.substr(0, 10)
                            }}</template>
                            <template v-slot:item.finalizado="{ item }">
                                <v-chip
                                    dense
                                    @click="changeFinalizado(item)"
                                    class="ma-2 white--text"
                                    :color="item.finalizado ? 'green' : 'red'"
                                    >{{
                                        item.finalizado
                                            ? "finalizado"
                                            : "en progreso"
                                    }}
                                </v-chip>
                            </template>
                            <template v-slot:item.action="{ item }">
                                <!--v-icon @click="editItem(item)" color="primary"
                                    >mdi-pencil</!--v-icon
                                -->
                                <v-icon @click="deleteItem(item)" color="red"
                                    >mdi-delete</v-icon
                                >
                            </template>
                        </v-data-table>
                    </v-card>
                </v-tab-item>
                <!-- Form Estado del Proyecto -->

                <!-- Form Archivo -->
                <v-tab-item class="pa-3 ma-1" v-if="admin || vendedor">
                    <tab-archivo
                        tipo="potencial"
                        :item="proyecto"
                    ></tab-archivo>
                </v-tab-item>
                <!-- Form Archivo -->

                <!-- Form Usuarios Asignados -->
                <v-tab-item class="pa-3 ma-1" v-if="admin || marketing">
                    <v-card flat>
                        <div class="font-weight-bold mb-3 black--text">
                            AGREGAR USUARIO A PROYECTO
                        </div>
                        <v-row dense>
                            <v-col cols="12" md="4">
                                <v-autocomplete
                                    dense
                                    outlined
                                    prepend-icon="mdi-account-search-outline"
                                    v-model="user_to_pick"
                                    :error-messages="
                                        errors.errors['empleado.nombre']
                                            ? errors.errors[
                                                  'enmpleado.nombre'
                                              ][0]
                                            : null
                                    "
                                    return-object
                                    :items="empleados"
                                    item-value="id"
                                    item-text="nombre"
                                    label="Seleccione o Cree empleado Nuevo"
                                >
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                        <div class="mb-5">
                            <v-btn
                                v-if="user_to_pick"
                                @click="addUserList()"
                                color="primary"
                                class="white--text"
                                rounded
                                >Agregar Usuario</v-btn
                            >
                        </div>
                        <v-data-table
                            :headers="headers_usuarios"
                            :items="itemsUsuarios"
                            :items-per-page="5"
                            class="elevation-1"
                        >
                            <template v-slot:item.fecha="{ item }">{{
                                item.fecha.substr(0, 10)
                            }}</template>
                            <template v-slot:item.role="{ item }">
                                <template v-if="item.usuario != null">
                                    {{
                                        item.usuario.role == 1
                                            ? "Administrador"
                                            : item.usuario.role == 2
                                            ? "Cliente"
                                            : item.usuario.role == 3
                                            ? "Empleado"
                                            : "Potencial"
                                    }}
                                </template>
                                <template v-else> Eliminado </template>
                            </template>
                            <template v-slot:item.action="{ item }">
                                <v-icon
                                    @click="deleteItemUsers(item)"
                                    color="red"
                                    >mdi-delete</v-icon
                                >
                            </template>
                        </v-data-table>
                    </v-card>
                </v-tab-item>
                <!-- Form Usuarios Asignados -->

                <!-- Form Seguimiento -->
                <v-tab-item
                    class="pa-3 ma-1"
                    v-if="(vendedor || role == 12) && proyecto.id != null"
                >
                    <v-card flat>
                        <div
                            style="
                                display: flex;
                                justify-content: space-between;
                            "
                        >
                            <div class="font-weight-bold mb-3 black--text">
                                AGREGAR TAREA A SEGUIMIENTO DEL PROYECTO
                            </div>
                            <v-btn
                                fab
                                color="success"
                                @click="dialog_whatsapp = true"
                            >
                                <v-icon color="white">mdi-whatsapp</v-icon>
                            </v-btn>
                        </div>
                        <v-row>
                            <v-col cols="12">
                                <v-form
                                    ref="formSeguimiento"
                                    v-model="formSeguimientoValid"
                                    class="mt-3"
                                >
                                    <v-row>
                                        <v-col cols="12">
                                            <date-select
                                                v-model="seguimiento.fecha"
                                                label="Fecha"
                                                :rules="[rules.required]"
                                            >
                                            </date-select>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-checkbox
                                                label="Alarma"
                                                v-model="seguimiento.alarma"
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col
                                            cols="6"
                                            v-if="role == 1 || role == 12"
                                        >
                                            <v-checkbox
                                                label="Seguimiento Proyecto"
                                                v-model="seguimiento.activo"
                                            ></v-checkbox>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-autocomplete
                                                outlined
                                                label="Horas"
                                                v-model="seguimiento.hora"
                                                :items="horas"
                                                item-value="value"
                                                item-text="text"
                                                :rules="[rules.required]"
                                            >
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-textarea
                                                outlined
                                                label="Comentario"
                                                v-model="seguimiento.comentario"
                                                :rules="[rules.required]"
                                            >
                                            </v-textarea>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12">
                                            <v-btn
                                                v-if="!seguimiento.id"
                                                :disabled="isloading"
                                                color="success"
                                                class="white--text"
                                                @click="saveSeguimiento"
                                                >Añadir</v-btn
                                            >
                                            <v-btn
                                                @click="saveSeguimiento"
                                                v-if="seguimiento.id"
                                                :disabled="isloading"
                                                color="success"
                                                class="white--text"
                                                >Actualizar</v-btn
                                            >
                                            <v-btn
                                                @click="deleteSeguimiento"
                                                v-if="seguimiento.id"
                                                :disabled="isloading"
                                                color="red"
                                                class="white--text"
                                                >Eliminar</v-btn
                                            >
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-col>
                        </v-row>
                        <v-data-table
                            dense
                            :headers="seguimientosHeaders"
                            :items="Seguimientos"
                            :items-per-page="15"
                            item-key="id"
                            class="elevation-1"
                            :sort-by="['nombre']"
                            :sort-desc="[false]"
                        >
                            <template v-slot:item.activo="{ item }">
                                <span>{{
                                    item.activo == 1 ? "Si" : "No"
                                }}</span>
                            </template>
                            <template v-slot:item.user_nombre="{ item }">
                                <span>{{
                                    item.user?.nombre ?? "Sin información"
                                }}</span>
                            </template>
                            <template v-slot:item.fecha="{ item }">
                                <span>{{ item.fecha | format_date }}</span>
                            </template>
                            <template v-slot:item.action="{ item }">
                                <v-icon
                                    @click="seguimiento = item"
                                    small
                                    class="mr-2"
                                    color="#1d2735"
                                    style="font-size: 25px"
                                    title="EDITAR"
                                    >mdi-pencil-outline</v-icon
                                >
                                <v-icon
                                    @click="deleteSeguimiento(item)"
                                    small
                                    class="mr-2"
                                    color="red"
                                    style="font-size: 25px"
                                    title="BORRAR"
                                    >mdi-trash-can</v-icon
                                >
                            </template>
                        </v-data-table>
                    </v-card>
                </v-tab-item>
                <!-- Form Seguimiento -->

                <!-- Resumen Pagos del Proyecto -->
                <v-tab-item class="pa-3 ma-1" v-if="admin">
                    <v-card flat>
                        <div class="font-weight-bold mb-4 black--text">
                            FACTURAS DEL PROYECTO
                        </div>
                        <v-data-table
                            :headers="headers_proyectos"
                            :items="facturasProyectos"
                            :items-per-page="5"
                            class="elevation-4"
                        >
                            <template v-slot:item.fecha="{ item }">{{
                                item.fecha.substr(0, 10)
                            }}</template>
                            <template v-slot:item.total="{ item }"
                                >{{ item.total }} €</template
                            >
                            <template
                                v-slot:item.total_pagos_ingresos="{ item }"
                                >{{ item.total_pagos_ingresos }} €</template
                            >
                        </v-data-table>
                    </v-card>
                    <div class="font-weight-bold my-4 black--text">
                        RESUMEN CONTABLE DEL PROYECTO
                    </div>
                    <v-card class="px-2 py-2 my-4 elevation-4">
                        <span class="font-weight-bold"
                            >Total Proyecto: {{ proyecto.pvp }} €</span
                        ><br />
                        <span class="font-weight-bold"
                            >Total Pagado:
                            {{ this.total_pagos_ingresos }} €</span
                        ><br />
                        <span class="font-weight-bold"
                            >Total Pendiente: {{ this.total_pendiente }} €</span
                        >
                    </v-card>
                </v-tab-item>
                <!-- Resumen Pagos del Proyecto -->

                <!-- Listado de tickets asociados al proyecto -->
                <v-tab-item class="pa-3 ma-1" v-if="proyecto.id != null">
                    <v-card flat>
                        <div class="d-flex justify-space-between align-center mb-4">
                            <div class="font-weight-bold black--text">
                                TICKETS DEL PROYECTO
                            </div>
                            <v-btn
                                color="success"
                                class="white--text"
                                @click="openNewTicketDialog"
                            >
                                <v-icon left>mdi-plus</v-icon>
                                Nuevo Ticket
                            </v-btn>
                        </div>
                        <TicketDataTableVue
                            ref="ticketDataTable"
                            :id_proyecto="proyecto.id"
                            :actions="false"
                            @open-ticket="openEditTicketDialog"
                        />
                    </v-card>
                </v-tab-item>
                <!-- Listado de tickets asociados al proyecto -->
            </v-tabs>
        </v-card>

        <!-- Botones Proyecto 1a linea -->
        <v-row class="mt-3" v-if="admin">
            <v-col cols="12">
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            fab
                            :to="{
                                path: `/registrar-presupuesto?id=${$route.query.id}`,
                            }"
                            :loading="isloading"
                            :disabled="isloading"
                            color="blue-grey lighten-2"
                            class="mx-2"
                            v-bind="attrs"
                            v-on="on"
                            readonly
                        >
                            <v-icon class="white--text"
                                >mdi-text-box-search-outline</v-icon
                            >
                        </v-btn>
                    </template>
                    <span>Ver Presupuesto</span>
                </v-tooltip>
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            fab
                            :to="{
                                path: `/registrr-facturas?cliente=${proyecto.usuario_id}`,
                            }"
                            :loading="isloading"
                            :disabled="isloading"
                            class="mx-2"
                            v-bind="attrs"
                            v-on="on"
                            readonly
                            style="background-color: #1d2735 !important"
                        >
                            <v-icon class="white--text">mdi-calculator</v-icon>
                        </v-btn>
                    </template>
                    <span>Crear Factura</span>
                </v-tooltip>
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            fab
                            :to="{
                                path: `/registrr-facturas-pro?cliente=${proyecto.usuario_id}`,
                            }"
                            :loading="isloading"
                            :disabled="isloading"
                            class="mx-2"
                            v-bind="attrs"
                            v-on="on"
                            readonly
                            style="background-color: #1d2735 !important"
                        >
                            <v-icon class="white--text"
                                >mdi-calculator-variant</v-icon
                            >
                        </v-btn>
                    </template>
                    <span>Crear Factura Proforma</span>
                </v-tooltip>
                <router-link
                    v-if="proyecto.id != null"
                    :to="`lista-facturas?id_cliente=${proyecto.usuario_id}`"
                >
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                fab
                                :loading="isloading"
                                :disabled="isloading"
                                class="mx-2"
                                v-bind="attrs"
                                v-on="on"
                                readonly
                                style="background-color: #1d2735 !important"
                            >
                                <v-icon class="white--text"
                                    >mdi-file-pdf</v-icon
                                >
                            </v-btn>
                        </template>

                        <span>Ver Facturas Enviadas</span>
                    </v-tooltip>
                </router-link>
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            fab
                            :loading="isloading"
                            :disabled="isloading"
                            color="amber accent-3"
                            class="mx-2"
                            v-bind="attrs"
                            v-on="on"
                            readonly
                        >
                            <v-icon class="white--text">mdi-at</v-icon>
                        </v-btn>
                    </template>
                    <span>Enviar Mail</span>
                </v-tooltip>
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            fab
                            @click="generarOrdenSEPA"
                            :loading="isloading"
                            :disabled="isloading || !proyecto.id"
                            color="green darken-1"
                            class="mx-2"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon class="white--text">mdi-bank-transfer</v-icon>
                        </v-btn>
                    </template>
                    <span>Crear Orden SEPA</span>
                </v-tooltip>
            </v-col>
        </v-row>
        <!-- Botones Proyecto 1a linea -->

        <!-- Botones Proyecto 2a linea -->
        <v-row class="mt-3">
            <v-col cols="12">
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            fab
                            @click="volver"
                            :loading="isloading"
                            :disabled="isloading"
                            color="blue"
                            class="mx-2"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon class="white--text"
                                >mdi-arrow-left-bold-outline</v-icon
                            >
                        </v-btn>
                    </template>
                    <span>Volver</span>
                </v-tooltip>
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            fab
                            @click="saveProyecto"
                            :loading="isloading"
                            :disabled="isloading"
                            color="success"
                            class="mx-2"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon class="white--text"
                                >mdi-content-save-all</v-icon
                            >
                        </v-btn>
                    </template>
                    <span>Guardar Proyecto</span>
                </v-tooltip>
            </v-col>
        </v-row>

        <!-- Botones Proyecto 1a linea -->
        <WhatsAppDialog
            :name="proyecto.usuario.nombre"
            v-model="dialog_whatsapp"
            :to="proyecto.usuario.telefono"
        >
        </WhatsAppDialog>

        <SemaforoEstadoFacturacion
            @change="setEstadoFacturacion"
            v-model="dialog_semaforo"
            :proyecto="proyecto"
        ></SemaforoEstadoFacturacion>

        <!-- Dialog para crear/editar ticket -->
        <TicketDialogVue
            v-model="ticketDialog"
            :ticket-id="selectedTicketId"
            :initial-proyecto-id="proyecto.id"
            @ticket-saved="handleTicketSaved"
            @close="handleTicketDialogClose"
        />
    </v-container>
</template>
<script>
import GastoExterno from "./GastoExterno.vue";
import WhatsAppDialog from "../../potenciales/componentes/WhatsAppDialog.vue";
import { provincias_mixin } from "../../../global_mixins/provincias_mixin";
import { servicios_mixin } from "../../../global_mixins/servicios_mixin";
import { productos_mixin } from "../../../global_mixins/productos_mixin";
import { estados_mixin } from "../../../global_mixins/estados_mixin";
import FileInput from "../../../global_components/FileInput.vue";
import VFileComponent from "../../../global_components/VFileComponent.vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import formUsuario from "./formUsuario.vue";
import tabArchivo from "../../../global_components/tabArchivo.vue";
import SemaforoEstadoFacturacion from "../../facturas/componentes/SemaforoEstadoFacturacion.vue";
import TicketDataTableVue from "../../../components/ticket/TicketDataTable.vue";
import TicketDialogVue from "../../../components/ticket/TicketDialog.vue";
import { rules } from "../../../utils/rules";
import { head } from "lodash";
import { formatPrice } from "../../../utils/formatters";
import DynamicSelect from "../../../components/general/dynamicSelect.vue";
import { mapGetters } from "vuex";

export default {
    components: {
        "file-input": FileInput,
        VFileComponent,
        formUsuario,
        tabArchivo,
        WhatsAppDialog,
        SemaforoEstadoFacturacion,
        TicketDataTableVue,
        TicketDialogVue,
        GastoExterno,
        DynamicSelect,
    },
    mixins: [provincias_mixin, servicios_mixin, estados_mixin, productos_mixin],
    data() {
        return {
            rules: rules,
            dialog_semaforo: false,
            dialog_whatsapp: false,
            ticketDialog: false,
            selectedTicketId: null,
            roles: [
                {
                    id: 1,
                    role: "Administrador",
                },
                {
                    id: 2,
                    role: "Cliente",
                },
            ],

            // Proyecto
            proyecto: {
                id: null,
                pvp: 0,
                semanal: 1,
                pvp_gasto: 0,
                lead_form: {
                    name: "",
                },
                gastos_externos: [],
                usuario: {
                    id: "",
                    user_id: localStorage.getItem("user_id"),
                    nombre: "",
                    nombre_fiscal: "",
                    cif: "",
                    telefono: "",
                    email: "",
                    role: 2,
                    direccion: "",
                    codigo_postal: "",
                    localidad: "",
                    provincia_id: 35,
                    cuenta: "00000000000000000000",
                    fecha_alta: new Date().toISOString().substr(0, 10),
                    observaciones: null,
                    avatar: null,
                    exento_iva: false,
                },
                estado_id: 2,
                servicio: {},
                producto_id: null,
                producto_precios: [],
                fecha_alta: new Date().toISOString().substr(0, 10),
                fecha_inicio_facturacion: new Date().toISOString().substr(0, 10),
                num_plazos: 1,
                fechas_plazos: [],
                detalle_servicio: null,
                detalles_gasto: null,
                nombre: "",
                numero_pedido: "",
                archivos: [],
                porc_realizado: 0,
                activo: false,
                observaciones: "",
                estado_facturacion: {
                    id: null,
                    id_proyecto: null,
                    parcial: 0,
                },
                num_trabajadores: 0,
            },
            proyecto_estados: [],
            producto_precios: [],
            producto_precio: {
                id: null,
                precio: 0,
                precio_anual: 0,
                min_usuarios: null,
                pago_unico: false,
                num_max_usuarios: null,
            },

            // Seguimiento
            formSeguimientoValid: true,
            seguimiento: {},
            Seguimientos: [],

            estado_edit: {},
            save_estado: {},

            estado: {
                id_estado: null,
            },

            user_to_pick: null,
            editor: ClassicEditor,
            editorData: "<p>Escriba Aqui Observaciones o contenido.</p>",
            editorConfig: {
                toolbar: {
                    items: [
                        "heading",
                        "bold",
                        "italic",
                        "bulletedList",
                        "numberedList",
                        "link",
                        "inserttable",
                    ],
                },
            },
            menu: false,
            menu: "",
            menu2: false,
            menu2: "",
            menu3: false,
            menu3: "",
            menu4: false,
            menu4: "",

            clienteId: null,
            servicio: {
                id: 1,
            },
            estado: {
                id: 1,
            },
            descripcion: "",
            fecha: new Date().toISOString().substr(0, 10),
            estado_proyecto_id: "",
            id_items_proyecto: [],
            finalizado: false,
            total_pagos_ingresos: 0, //
            total_pendiente: 0, //
            headers: [
                {
                    text: "Descripcion",
                    value: "descripcion",
                    sortable: false,
                },
                {
                    text: "Fecha",
                    value: "fecha",
                    sortable: false,
                },
                {
                    text: "Estado",
                    value: "finalizado",
                    sortable: false,
                },
                {
                    text: "Acciones",
                    value: "action",
                    sortable: false,
                },
            ],
            headers_usuarios: [
                {
                    text: "id",
                    value: "id_usuario",
                    sortable: false,
                },
                {
                    text: "Nombre",
                    value: "usuario.nombre",
                    sortable: false,
                },
                {
                    text: "Nombre Fiscal",
                    value: "usuario.nombre_fiscal",
                    sortable: false,
                },
                {
                    text: "Rol",
                    value: "role",
                    sortable: false,
                },
                {
                    text: "Acciones",
                    value: "action",
                    sortable: false,
                },
            ],
            headers_proyectos: [
                {
                    text: "Num. Factura",
                    value: "nro_anio_factura",
                    sortable: false,
                },
                {
                    text: "Fecha Factura",
                    value: "fecha",
                    sortable: false,
                },
                {
                    text: "Importe Factura",
                    value: "total",
                    sortable: false,
                },
                {
                    text: "Ingresos Totales Factura",
                    value: "total_pagos_ingresos",
                    sortable: false,
                },
            ],

            usuarios: [],
            files: [],
            imagePreview: [],
            csrf: document
                .querySelector('meta[name="csrf-token"]')
                .getAttribute("content"),
            user_id: localStorage.getItem("user_id"),
            base_64_image: null,
            items: [],
            itemsEstado: [],
            itemsUsuarios: [],
            empleados: [],
            ingresosProyecto: [],
            facturasProyectos: [],
            horas: [],
            // estados: [],
        };
    },
    async created() {
        if (this.$route.query.id) {
            await this.getProyectoById(this.$route.query.id);
        }

        this.clienteid = this.$route.query.clienteid;

        this.getUsuarios();
        this.getEmpleados();
        this.generateHoras();
        this.fillClienteId();
        this.getProyectoEstado();
        this.getEstados();
    },

    methods: {
        // Generar fechas de plazos automáticamente
        generarFechasPlazos() {
            if (this.proyecto.tipo_proyecto !== 3) {
                this.proyecto.fechas_plazos = [];
                return;
            }
            const numPlazos = Number(this.proyecto.num_plazos) || 0;
            const fechaInicio = new Date(this.proyecto.fecha_inicio_facturacion);
            const pvp = Number(String(this.proyecto.pvp || 0).replace(/[^0-9.,-]/g, '').replace(',', '.')) || 0;
            const importeBase = numPlazos > 0 ? (pvp / numPlazos) : 0;

            const actuales = Array.isArray(this.proyecto.fechas_plazos) ? this.proyecto.fechas_plazos : [];
            const nuevos = [];
            for (let i = 0; i < numPlazos; i++) {
                const existente = actuales[i];
                const fechaPlazo = new Date(fechaInicio);
                fechaPlazo.setMonth(fechaPlazo.getMonth() + i);
                const fechaISOporDefecto = fechaPlazo.toISOString().substr(0, 10);
                nuevos.push({
                    fecha: (existente && existente.fecha) ? existente.fecha : fechaISOporDefecto,
                    importe: (existente && existente.importe != null && existente.importe !== '') ? existente.importe : importeBase.toFixed(2),
                });
            }
            this.proyecto.fechas_plazos = nuevos;
        },
        formatDateDDMMYYYY(isoDate) {
            if (!isoDate) return '';
            const d = new Date(isoDate);
            const dd = String(d.getDate()).padStart(2, '0');
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const yyyy = d.getFullYear();
            return `${dd}-${mm}-${yyyy}`;
        },
        generarOrdenSEPA() {
            if (!this.proyecto.id) {
                this.$toast.error("Debe guardar el proyecto primero");
                return;
            }
            this.isloading = true;
            axios
                .get(`api/generar-orden-sepa/${this.proyecto.id}`, {
                    responseType: 'blob'
                })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `orden_sepa_${this.proyecto.id}.pdf`);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                    this.$toast.sucs("Orden SEPA generada correctamente");
                    this.isloading = false;
                })
                .catch((error) => {
                    this.$toast.error("Error al generar la orden SEPA");
                    this.isloading = false;
                    console.error(error);
                });
        },
        inputPrice(value) {
            // Si es un evento, obtener el valor del target
            const rawValue = value && value.target ? value.target.value : value;

            // Convertir a string y limpiar caracteres no numéricos excepto punto y coma
            const cleanValue = String(rawValue).replace(/[^0-9.,]/g, '');

            // Reemplazar coma por punto para decimales
            const normalizedValue = cleanValue.replace(',', '.');

            // Convertir a número
            const num = parseFloat(normalizedValue);

            // Si no es un número válido, devolver el valor original limpio
            if (isNaN(num)) {
                return cleanValue;
            }

            // Devolver el número sin formatear para permitir edición natural
            return num.toString();
        },

        // Acciones de tab "Proyecto"
        //adaptamos el getProyectoById para traernos los items de estados en la edición
        async getProyectoById(proyecto_id) {
            try {
                const response = await axios.get(
                    `api/get-proyecto-by-id/${proyecto_id}`
                );
                this.proyecto = response.data;

                // Debug: Log fechas_plazos al cargar
                console.log('Fechas plazos al cargar proyecto:', this.proyecto.fechas_plazos);

                // Asegurar que observaciones no sea null/undefined para CKEditor
                this.proyecto.observaciones = this.proyecto.observaciones || '';

                // Inicializar campos de plazos si no existen
                if (!this.proyecto.fecha_inicio_facturacion) {
                    this.proyecto.fecha_inicio_facturacion = this.proyecto.fecha_alta || new Date().toISOString().substr(0, 10);
                }
                if (!this.proyecto.num_plazos) {
                    this.proyecto.num_plazos = 1;
                }
                if (!this.proyecto.fechas_plazos) {
                    this.proyecto.fechas_plazos = [];
                }

                // Normalizar estructura de fechas_plazos a objetos {fecha, importe}
                if (Array.isArray(this.proyecto.fechas_plazos)) {
                    this.proyecto.fechas_plazos = this.proyecto.fechas_plazos.map((f) => {
                        if (typeof f === 'string') {
                            return { fecha: f, importe: null };
                        }
                        if (f && typeof f === 'object') {
                            return { fecha: f.fecha || '', importe: f.importe ?? null };
                        }
                        return { fecha: '', importe: null };
                    });
                }

                this.itemsEstado = response.data.estados_proyecto;
                this.itemsUsuarios = response.data.usuarios ?? [];
                this.pushItemsEstadoId(this.itemsEstado);
                this.getingresosByProyecto(proyecto_id);
                this.getSeguimientos();
            } catch (error) {
                console.log(error);
            }
        },
        async saveProyecto() {
            try {
                if (this.proyecto.activo) {
                    this.proyecto.activo = true;
                } else {
                    this.proyecto.activo = false;
                }

                // Debug: Log fechas_plazos antes de enviar
                console.log('Fechas plazos antes de guardar:', this.proyecto.fechas_plazos);

                var formData = new FormData();
                formData.append("proyecto", JSON.stringify(this.proyecto));
                formData.append(
                    "itemsEstado",
                    JSON.stringify(this.itemsEstado)
                );
                formData.append(
                    "idItemsEstado",
                    JSON.stringify(this.id_items_proyecto)
                );
                formData.append("usuarios", JSON.stringify(this.itemsUsuarios));

                let archivos = this.proyecto.archivos.filter(
                    (archivo) => !archivo.id
                );
                archivos.forEach((item, i) =>
                    formData.append("itemsFiles[" + i + "]", item.file)
                );

                let res = await axios.post("api/save-proyecto", formData);
                this.proyecto = res.data.proyecto;
                this.$toast.sucs("Proyecto guardado con éxito");
            } catch (error) {
                this.$toast.error(
                    "Error guardando Proyecto, Compruebe todos los campos requeridos"
                );
            }
        },
        pushItemsEstadoId(items) {
            const itemsPreview = items;
            Object.keys(itemsPreview).forEach((i) => {
                this.id_items_proyecto.push(itemsPreview[i].id);
            });
        },
        getingresosByProyecto(proyecto_id) {
            this.total_pagos_ingresos = 0;
            this.total_pendiente = 0;
            axios.get(`api/get-ingreso-by-pro_id/${proyecto_id}`).then(
                (res) => {
                    this.ingresosProyectos = res.data;
                    this.total_pagos_ingresos = parseFloat(
                        this.ingresosProyectos.total_pagos_ingresos
                    ).toFixed(2);
                    this.total_pendiente = parseFloat(
                        this.proyecto.pvp -
                            this.ingresosProyectos.total_pagos_ingresos
                    ).toFixed(2);
                    this.getFacturasByProyecto(proyecto_id);
                },
                (err) => {
                    this.$toast.error(
                        "Error consultando Ingresos de proyectos"
                    );
                }
            );
        },
        getFacturasByProyecto(proyecto_id) {
            axios.get(`api/get-facturas-by-proyecto/${proyecto_id}`).then(
                (res) => {
                    this.facturasProyectos = res.data;
                    if (this.facturasProyectos.length > 0) {
                        this.facturasProyectos[0].total_pagos_ingresos =
                            this.total_pagos_ingresos;
                    }
                },
                (err) => {
                    this.$toast.error("Error consultando Facturas");
                }
            );
        },
        setEstadoFacturacion(item) {
            this.proyecto.estado_facturacion = item;
        },

        // Acciones de tab "Cliente"
        fillClienteId() {
            if (this.$route.query.clienteid) {
                axios
                    .get(`api/get-usuario-by-id/${this.clienteid}`)
                    .then((res) => {
                        this.proyecto.usuario = res.data.user;
                    });
            }
        },

        // Acciones del tab "estado del proyecto"
        saveproyectoEstado() {
            axios
                .post("api/save-proyecto-estados", this.save_estado)
                .then((res) => {
                    this.getProyectoEstado();
                    this.save_estado = {};
                });
        },
        deleteProyectoEstado(id) {
            axios
                .post("api/delete-proyecto-estados", {
                    id: id,
                })
                .then((res) => {
                    this.getProyectoEstado();
                });
        },
        addStatus() {
            if (this.estado.id_estado != "") {
                let str = this.proyecto_estados.find(
                    (element) => element.id == this.estado.id_estado
                );
                const estado = {
                    estado: str,
                    id_estado: this.estado.id_estado,
                    fecha: this.fecha,
                    finalizado: this.finalizado,
                };
                this.itemsEstado.push(estado);
            }
            this.estado_proyecto_id = "";
            this.descripcion = "";
            this.finalizado = false;
            this.fecha = new Date().toISOString().substr(0, 10);
        },
        deleteItem(item) {
            let idstring = item.id.toString();
            if (idstring.includes("a")) {
                const search = this.itemsEstado.findIndex(
                    (val) => val.id === idstring
                );
                if (search > -1) {
                    this.itemsEstado.splice(search, 1);
                    this.id_items_proyecto.splice(search, 1);
                }
            } else {
                const search = this.itemsEstado.findIndex(
                    (val) => val.id == item.id
                );
                if (search > -1) {
                    this.itemsEstado.splice(search, 1);
                    this.id_items_proyecto.splice(search, 1);
                }
                axios.get(`api/delete-proyecto-estado/${item.id}`).then(
                    (res) => {
                        this.$toast.sucs(
                            "Estado existente borrado exitosamente"
                        );
                    },
                    (err) => {
                        this.$toast.error("Error al borrar estado");
                    }
                );
            }
        },
        editItem(item) {
            this.estado_edit.index = this.itemsEstado.indexOf(item);
            this.estado_edit.id = item.id;
            this.estado_edit.descripcion = item.descripcion;
            this.estado_edit.fecha = item.fecha.substr(0, 10);
            this.estado_edit.finalizado = item.finalizado;
            this.dialog_estado = 1;
        },
        changeFinalizado(itemE) {
            if (itemE.id == null) {
                itemE.finalizado = !itemE.finalizado;
                this.$toast.warn(
                    "Estado actualizado, los cambios se harán efectivos al presionar el botón guardar"
                );
            } else {
                axios.get(`api/update-project-status/${itemE.id}`).then(
                    (res) => {
                        itemE.finalizado = !itemE.finalizado;
                        this.$toast.sucs("Estado actualizado");
                    },
                    (err) => {
                        this.$toast.error(
                            "Debe guardar/actualizar antes de poder cambiar el estado"
                        );
                    }
                );
            }
        },

        // Acciones del tab "usuarios asignados"
        addUserList() {
            // this.getEmpleados();
            // this.user_to_pick = this.empleados;
            if (this.user_to_pick != null) {
                // console.log(this.user_to_pick);
                let finusuraio = this.itemsUsuarios.find(
                    (element) => element.id_usuario == this.user_to_pick.id
                );
                if (finusuraio == null) {
                    let elemento = {
                        id_usuario: this.user_to_pick.id,
                        usuario: this.user_to_pick,
                    };

                    this.itemsUsuarios.push(elemento);
                }
            }
            this.user_to_pick = null;
        },
        deleteItemUsers(item) {
            // console.log(item);
            const search = this.itemsUsuarios.findIndex(
                (val) => val.id_usuario === item.id_usuario
            );
            if (search > -1) {
                this.itemsUsuarios.splice(search, 1);
            }
        },

        // Acciones de tab "Seguimiento"
        getSeguimientos() {
            const self = this;
            axios
                .get(`api/get-tareas-proyecto?cliente=${this.proyecto.id}`)
                .then(
                    (res) => {
                        self.Seguimientos = res.data;
                    },
                    (err) => {
                        this.$toast.error("Error consultando Seguimientos");
                    }
                );
        },
        saveSeguimiento() {
            const self = this;

            self.$refs.formSeguimiento.validate();
            if (self.formSeguimientoValid) {
                self.seguimiento.id_proyecto = self.proyecto.id;
                axios
                    .post("api/save-tareas-proyecto", self.seguimiento)
                    .then(function (response) {
                        self.seguimiento = {};
                        self.getSeguimientos();
                    });
            }
        },
        deleteSeguimiento(item) {
            axios
                .post("api/cancel-tareas-proyecto", {
                    id: item.id,
                })
                .then(
                    (res) => {
                        this.$toast.sucs("Seguimiento eliminado");
                        this.dialog = false;
                        this.getSeguimientos();
                    },
                    (err) => {
                        this.$toast.error("Error eliminando Seguimiento");
                    }
                );
        },

        // Metodos generales
        getUsuarios() {
            axios.get(`api/get-usuarios`).then(
                (res) => {
                    this.usuarios = res.data.users;
                },
                (err) => {
                    this.$toast.error("Error consultando clientes");
                }
            );
        },
        getEmpleados() {
            axios.post(`api/get-usuarios-empleados`, this.filtros).then(
                (res) => {
                    this.empleados = res.data.users.data;
                    this.empleados.unshift("");
                },
                (err) => {
                    this.$toast.error("Error consultando empleados");
                }
            );
        },
        generateHoras() {
            this.horas = [];
            for (let val = 9; val <= 19; val += 0.5) {
                let str = val.toString().split(".");
                let txt = "";
                if (str.length > 1) {
                    txt = str[0].toString().padStart(2, "0") + ":30";
                } else {
                    txt = val.toString().padStart(2, "0") + ":00";
                }
                this.horas.push({
                    text: txt,
                    value: val,
                });
            }
        },
        getProyectoEstado() {
            axios.get("api/get-proyecto-estados").then((res) => {
                this.proyecto_estados = res.data;
            });
        },
        volver() {
            // volver al crear
            let tipo = "";
            if (
                this.$route.query.tipo != null &&
                this.$route.query.tipo != "null"
            ) {
                tipo = "&tipo=" + this.$route.query.tipo;
            }
            if (this.$route.query.seguimiento_cliente == "1") {
                let fecha = "";
                if (this.$route.query.fecha != null) {
                    fecha = `?fecha=${this.$route.query.fecha}`;
                }
                this.$router.push(`/calendario-seguimiento-cliente${fecha}`);
            } else if (this.clienteid) {
                this.$router.push(
                    `/${this.$route.meta.to}?id=${this.clienteid}${tipo}`
                );
            }
            // volver al editar
            else {
                this.$router.push(
                    `/${this.$route.meta.to}?id=${this.proyecto.usuario.id}${tipo}`
                );
            }
        },
        setFiles(files) {
            const filesPreview = files;
            Object.keys(filesPreview).forEach((i) => {
                const file = filesPreview[i];
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.imagePreview.push(reader.result);
                };
                this.imagePreview = [];
                reader.readAsDataURL(file);
            });
            if (files !== undefined) {
                this.files = files;
                this.disableUploadButtonImage = false;
            }
        },
        deleteFile(item) {
            const index = this.items.findIndex((val) => val.name == item.name);
            if (index > -1) {
                this.items.splice(index, 1);
            }
        },
        productoSeleccionado() {
            const producto = this.productos.find(
                (producto) => producto.id == this.proyecto.producto_id
            );

            if (producto != undefined && producto != null) {
                this.proyecto.pvp = producto.precio;
                this.proyecto.minutos_estimados = producto.minutos;
                this.proyecto.detalle_servicio = producto.descripcion;
            } else {
                this.proyecto.pvp = 0;
                this.proyecto.minutos_estimados = 0;
                this.proyecto.detalle_servicio = "";
            }

            // Si el producto no es yotico entonces no se puede introducir el numero de trabajadores
            if (this.proyecto.producto_id != 51) {
                this.proyecto.num_trabajadores = null;
            }
        },
        formatPrice,
        obtenerImporteRecurrente(tarifa) {
            if (!tarifa) {
                return 0;
            }
            // Leer directamente del proyecto para asegurar reactividad
            const tipoProyecto = this.proyecto.tipo_proyecto;
            const esAnual = tipoProyecto === 4;

            let base;
            if (esAnual) {
                // Si es anual, usar precio_anual si existe, sino usar precio, y multiplicar por 12
                const precioAnual = Number(tarifa.precio_anual || 0);
                const precioMensual = Number(tarifa.precio || 0);
                base = (precioAnual > 0 ? precioAnual : precioMensual) * 12;
            } else {
                // Si es mensual, usar precio mensual
                base = Number(tarifa.precio || 0);
            }

            if (tarifa.fijo) {
                return base;
            }

            // Leer directamente del proyecto para asegurar reactividad
            const trabajadores =
                Number(this.proyecto.num_trabajadores || 0) || 0;

            return base * trabajadores;
        },
        obtenerDesgloseTarifa(tarifa) {
            if (!tarifa) {
                return null;
            }
            const tipoProyecto = this.proyecto.tipo_proyecto;
            const esAnual = tipoProyecto === 4;
            const trabajadores = Number(this.proyecto.num_trabajadores || 0) || 0;

            let precioBase;
            let tienePrecioAnual = false;
            if (esAnual) {
                // Si es anual, usar precio_anual si existe, sino usar precio, y multiplicar por 12
                const precioAnual = Number(tarifa.precio_anual || 0);
                const precioMensual = Number(tarifa.precio || 0);
                tienePrecioAnual = precioAnual > 0;
                precioBase = (precioAnual > 0 ? precioAnual : precioMensual) * 12;
            } else {
                precioBase = Number(tarifa.precio || 0);
            }

            const desglose = {
                descripcion: tarifa.descripcion || 'Tarifa',
                tipo: tarifa.fijo ? 'Fijo' : 'Variable',
                precioBase: precioBase,
                precioMensual: Number(tarifa.precio || 0),
                trabajadores: trabajadores,
                multiplicador: tarifa.fijo ? 1 : trabajadores,
                total: this.obtenerImporteRecurrente(tarifa),
                esAnual: esAnual,
                tienePrecioAnual: tienePrecioAnual
            };

            return desglose;
        },
        async saveProductoPrecios(producto_precio, idProyecto) {
            try {
                await this.$store.dispatch("saveProductoPrecios", {
                    producto_precio,
                    idProyecto,
                });
                // Usamos directamente el getter ya que el store ya se actualizó
                this.producto_precios =
                    this.$store.getters.get_producto_precios;
            } catch (error) {
                console.error("Error al guardar precio:", error);
            }
        },
        async deleteProductoPrecios(id) {
            try {
                const item = this.producto_precios.find(
                    (item) => item.id == id
                );
                await this.$store.dispatch("deleteProductoPrecios", {
                    idProductoPrecio:
                        item.id_proyecto_producto_precio ?? item.id,
                    idProyecto: this.proyecto.id,
                });

                // actualizamos el store
                await this.$store.dispatch("getProductoPrecios", {
                    idProducto: this.proyecto.producto_id,
                    idProyecto: this.proyecto.id,
                });

                this.producto_precios =
                    this.$store.getters.get_producto_precios;
            } catch (error) {
                console.error("Error al eliminar precio:", error);
            }
        },
        // Métodos para el dialog de tickets
        openNewTicketDialog() {
            this.selectedTicketId = null;
            this.ticketDialog = true;
        },
        openEditTicketDialog(ticketId) {
            this.selectedTicketId = ticketId;
            this.ticketDialog = true;
        },
        handleTicketSaved() {
            // Refrescar la tabla de tickets
            if (this.$refs.ticketDataTable) {
                this.$refs.ticketDataTable.getItems();
            }
        },
        handleTicketDialogClose() {
            this.selectedTicketId = null;
        },
    },
    watch: {
        "proyecto.fecha_inicio_facturacion": function (newVal) {
            if (this.proyecto.tipo_proyecto === 3) {
                this.generarFechasPlazos();
            }
        },
        "proyecto.tipo_proyecto": function (newVal, oldVal) {
            if (newVal === 3) {
                if (!Array.isArray(this.proyecto.fechas_plazos) || this.proyecto.fechas_plazos.length === 0) {
                    this.generarFechasPlazos();
                }
            } else {
                this.proyecto.fechas_plazos = [];
            }
        },
        "proyecto.num_plazos": function (newVal, oldVal) {
            if (this.proyecto.tipo_proyecto === 3 && oldVal !== undefined && newVal !== oldVal) {
                // solo generar si no hay plazos; si ya hay, respeta lo existente
                if (!Array.isArray(this.proyecto.fechas_plazos) || this.proyecto.fechas_plazos.length === 0) {
                    this.generarFechasPlazos();
                }
            }
        },
        "proyecto.pvp": function (newVal, oldVal) {
            if (this.proyecto.tipo_proyecto === 3 && oldVal !== undefined && newVal !== oldVal) {
                // no pisar importes si ya existen; solo rellenar vacíos
                const numPlazos = Number(this.proyecto.num_plazos) || 0;
                const pvp = Number(String(this.proyecto.pvp || 0).replace(/[^0-9.,-]/g, '').replace(',', '.')) || 0;
                const importeBase = numPlazos > 0 ? (pvp / numPlazos) : 0;
                if (Array.isArray(this.proyecto.fechas_plazos)) {
                    this.proyecto.fechas_plazos = this.proyecto.fechas_plazos.map(plazo => ({
                        fecha: plazo.fecha,
                        importe: (plazo.importe != null && plazo.importe !== '') ? plazo.importe : importeBase.toFixed(2),
                    }));
                }
            }
        },
        "proyecto.producto_id": function (newVal) {
            if (newVal) {
                this.$store
                    .dispatch("getProductoPrecios", {
                        idProducto: newVal,
                        idProyecto: this.proyecto.id,
                    })
                    .then((precios) => {
                        this.producto_precios = precios;
                    });
            }
        },
        "proyecto.producto_precios": {
            deep: true,
            handler(newVal) {
                if (
                    Array.isArray(newVal) &&
                    newVal.length > 0 &&
                    this.proyecto.id == null
                ) {
                    this.proyecto.pvp = newVal
                        .reduce((acc, curr) => {
                            let precio = 0;
                            if (curr.fijo) {
                                precio = curr.precio;
                            } else {
                                precio =
                                    curr.precio *
                                    this.proyecto.num_trabajadores;
                            }
                            return acc + parseFloat(precio || 0);
                        }, 0)
                        .toFixed(2);
                } else {
                    this.proyecto.pvp = this.proyecto.pvp;
                }
            },
        },
    },
    computed: {
        ...mapGetters({
            userRole: "auth/userRole",
        }),
        tarifasSeleccionadas() {
            return Array.isArray(this.proyecto.producto_precios)
                ? this.proyecto.producto_precios
                : [];
        },
        pagoInicialTarifas() {
            return this.tarifasSeleccionadas.filter(
                (tarifa) => tarifa?.pago_unico === true
            );
        },
        pagoRecurrenteTarifas() {
            return this.tarifasSeleccionadas.filter(
                (tarifa) => tarifa?.pago_unico !== true
            );
        },
        usaPrecioAnual() {
            return this.proyecto.tipo_proyecto === 4;
        },
        textoPagoRecurrente() {
            // Leer directamente del proyecto para asegurar reactividad
            const tipoProyecto = this.proyecto.tipo_proyecto;
            if (tipoProyecto === 4) {
                return "el precio anual";
            }
            return "el precio mensual";
        },
        pagoInicialTotal() {
            return this.pagoInicialTarifas.reduce((acc, tarifa) => {
                return acc + Number(tarifa?.precio || 0);
            }, 0);
        },
        pagoRecurrenteTarifasConImporte() {
            // Forzar dependencia reactiva de tipo_proyecto y num_trabajadores
            const tipoProyecto = this.proyecto.tipo_proyecto;
            const numTrabajadores = this.proyecto.num_trabajadores;

            return this.pagoRecurrenteTarifas.map(tarifa => ({
                ...tarifa,
                importeCalculado: this.obtenerImporteRecurrente(tarifa),
                desglose: this.obtenerDesgloseTarifa(tarifa)
            }));
        },
        pagoRecurrenteTotal() {
            // Forzar dependencia reactiva de tipo_proyecto y num_trabajadores
            const tipoProyecto = this.proyecto.tipo_proyecto;
            const numTrabajadores = this.proyecto.num_trabajadores;

            return this.pagoRecurrenteTarifas.reduce((acc, tarifa) => {
                return acc + this.obtenerImporteRecurrente(tarifa);
            }, 0);
        },
        getColorFacturacion() {
            const item = this.proyecto;
            if (item.estado_facturacion == null) {
                return {
                    color: "red",
                    text: "Pendiente Facturar",
                };
            }
            if (item.estado_facturacion.parcial == 1) {
                return {
                    color: "yellow",
                    text: "Facturado parcial",
                };
            }

            return {
                color: "green",
                text: "Facturado",
            };
        },
        admin() {
            const role = this.userRole;
            const permisos = localStorage.getItem("permisos");
            return (
                role == 1 ||
                role == 5 ||
                role == 7 ||
                role == 12 ||
                permisos?.includes("Clientes")
            );
        },
        marketing() {
            const role = this.userRole;

            return role == 6;
        },
        vendedor() {
            const role = this.userRole;
            return role == 1 || role == 5 || role == 7 || role == 9;
        },
        role() {
            return this.userRole;
        },
        isloading() {
            return this.$store.getters.getloading;
        },
        errors() {
            return this.$store.getters.geterrors;
        },
        seguimientosHeaders() {
            let headers = [
                {
                    text: "Nombre",
                    value: "proyecto.nombre",
                    sortable: false,
                },
                {
                    text: "comentario",
                    value: "comentario",
                    sortable: false,
                },
                {
                    text: "Fecha",
                    value: "fecha",
                    sortable: false,
                },
                {
                    text: "Acciones",
                    value: "action",
                    sortable: false,
                },
            ];

            // Se agrega esta columna si el usuario es administrador,
            // gestor proyectos o supervisor de markenting
            if (
                this.userRole == 1 ||
                this.userRole == 12 ||
                this.userRole == 7
            ) {
                const element = {
                    text: "Seguimineto proyecto",
                    value: "activo",
                    align: "center",
                    sortable: false,
                };

                const element2 = {
                    text: "Creador",
                    value: "user_nombre",
                    sortable: false,
                };

                headers.splice(2, 0, element);
                headers.splice(3, 0, element2);
            }

            return headers;
        },
    },
};
</script>
<style>
div.v-messages.theme--light {
    margin-top: -1px !important;
    margin-bottom: -1px !important;
    padding-top: -1px !important;
    padding-bottom: -1px !important;
}

div.v-text-field__details {
    margin-top: -1px !important;
    margin-bottom: -1px !important;
    padding-top: -1px !important;
    padding-bottom: -1px !important;
}
</style>
